import React, { useState } from 'react';
import axios from 'axios';
import './AdminQuestions.css';
import API_BASE_URL from '../../config';

const AdminQuestions = () => {
    const [testId, setTestId] = useState('');
    const [examType, setExamType] = useState('reading');

    const [questions, setQuestions] = useState([
        {
            question_number: 1,
            question_type: 'mcq_one',
            question_text: '',
            options: ['TRUE', 'FALSE', 'NOT GIVEN', ''],
            correct_answer: ''
        }
    ]);

    const getNextQuestionNumber = () => {
        if (questions.length === 0) return 1;
        return Math.max(...questions.map(q => Number(q.question_number) || 0)) + 1;
    };

    const loadExistingQuestions = async () => {
        if (!testId) return alert("Nhập mã đề!");
        try {
            
            const res = await axios.get(`${API_BASE_URL}/api/questions`, {
                params: { type: examType, testId }
            });
            if (res.data.length > 0) {
                const formatted = res.data.map(q => ({
                    question_number: Number(q.question_number),
                    question_type: q.question_type || 'text',
                    question_text: q.question_text || '',
                    correct_answer: q.correct_answer || '',
                    options: typeof q.options === 'string'
                        ? JSON.parse(q.options)
                        : (q.options || ['', '', '', ''])
                }));
                setQuestions(formatted);
                alert("Đã tải dữ liệu!");
            } else {
                alert("Chưa có câu hỏi.");
            }
        } catch (e) {
            console.error(e);
            alert("Lỗi load");
        }
    };

    const handleQuestionChange = (index, field, value) => {
        const updated = [...questions];
        updated[index][field] = value;
        setQuestions(updated);
    };

    const handleOptionChange = (qIndex, optIndex, value) => {
        const updated = [...questions];
        updated[qIndex].options[optIndex] = value;
        setQuestions(updated);
    };

    // ✅ Logic xử lý chọn đáp án (Hỗ trợ cả Single và Multi)
    const handleToggleCorrect = (qIndex, optValue) => {
        const updated = [...questions];
        const q = updated[qIndex];

        if (q.question_type === 'mcq_multi') {
            // Nhiều đáp án: Thêm hoặc xóa khỏi chuỗi (cách nhau bởi dấu phẩy)
            let currentAnswers = q.correct_answer ? q.correct_answer.split(',') : [];
            if (currentAnswers.includes(optValue)) {
                currentAnswers = currentAnswers.filter(a => a !== optValue);
            } else {
                currentAnswers.push(optValue);
            }
            q.correct_answer = currentAnswers.sort().join(',');
        } else {
            // Một đáp án: Thay thế luôn
            q.correct_answer = optValue;
        }
        setQuestions(updated);
    };

    const addQuestion = () => {
        setQuestions([
            ...questions,
            {
                question_number: getNextQuestionNumber(),
                question_type: 'text',
                options: ['', '', '', ''],
                question_text: '',
                correct_answer: ''
            }
        ]);
    };

    const saveAll = async () => {
    if (!testId || testId.trim() === "") {
        return alert("Bắt buộc nhập mã đề!");
    }

    const token = localStorage.getItem("token"); // ✅ THÊM DÒNG NÀY
    console.log("TOKEN QUESTIONS:", token); // debug

    if (!token) {
        return alert("Bạn chưa đăng nhập!");
    }

    try {
        const finalData = questions.map((q, index) => {
            let cleanOptions = Array.isArray(q.options) ? q.options : [];
            cleanOptions = cleanOptions.map(opt => String(opt || '').trim());
            return {
                test_id: testId.trim(),
                exam_type: examType,
                question_number: Number(q.question_number) || (index + 1),
                type: q.question_type,
                content: q.question_text,
                correct_answer: q.correct_answer || '',
                options: cleanOptions
            };
        });

        const res = await axios.post(
            `${API_BASE_URL}/api/questions/bulk`,
            { questions: finalData },
            {
                headers: {
                    Authorization: `Bearer ${token}` // ✅ THÊM HEADER
                }
            }
        );

        alert(res.data.message);

    } catch (e) {
        console.error(e);
        alert("Lỗi: " + (e.response?.data?.error || e.message));
    }
};

    const removeQuestion = (index) => {
        const updated = questions.filter((_, i) => i !== index);
        setQuestions(updated);
    };

    return (
        <div className="admin-page-container">
            <div className="admin-content-wrapper">
                <div className="page-header-section">
                    <h2 className="page-title">Question Bank Management ⚙️</h2>
                    <p className="page-subtitle">Configure questions for Test ID: {testId || '...'}</p>
                </div>

                <div className="admin-card-form filter-action-bar">
                    <div className="form-section-grid" style={{marginBottom: 0, gridTemplateColumns: '1fr 1fr 100px'}}>
                        <div className="form-group" style={{marginBottom: 0}}>
                            <label>Target Test ID</label>
                            <input
                                className="modern-input"
                                placeholder="Enter Test ID (e.g. cam_18_t1)"
                                value={testId}
                                onChange={e => setTestId(e.target.value)}
                            />
                        </div>
                        <div className="form-group" style={{marginBottom: 0}}>
                            <label>Exam Skill Type</label>
                            <select
                                className="modern-select"
                                value={examType}
                                onChange={e => setExamType(e.target.value)}
                            >
                                <option value="reading">Reading Exam</option>
                                <option value="listening">Listening Exam</option>
                            </select>
                        </div>
                        <div className="form-group" style={{marginBottom: 0, justifyContent: 'flex-end'}}>
                            <button onClick={loadExistingQuestions} className="btn-check" style={{height: '48px', width: '100%'}}>
                                Load
                            </button>
                        </div>
                    </div>
                </div>

                <div className="questions-list-container">
                    {questions.map((q, qIndex) => (
                        <div key={qIndex} className={`question-card-item ${examType}`}>
                            <div className="question-card-header">
                                <span className="question-badge">Question {q.question_number}</span>
                                <div className="header-actions">
                                    <select
                                        className="modern-select-sm"
                                        value={q.question_type}
                                        onChange={e => handleQuestionChange(qIndex, 'question_type', e.target.value)}
                                    >
                                        <option value="mcq_one">MCQ (Single Choice)</option>
                                        <option value="mcq_multi">MCQ (Multiple Choice)</option>
                                        <option value="text">Gap Filling / Short Answer</option>
                                    </select>
                                    <button className="btn-delete-small" onClick={() => removeQuestion(qIndex)}>🗑️</button>
                                </div>
                            </div>

                            <div className="question-card-body">
                                <label className="input-label">Question Text / Instruction:</label>
                                <textarea
                                    className="modern-textarea"
                                    placeholder="Type the question content here..."
                                    value={q.question_text}
                                    onChange={e => handleQuestionChange(qIndex, 'question_text', e.target.value)}
                                />

                                {(q.question_type === 'mcq_one' || q.question_type === 'mcq_multi') ? (
                                    <div className="mcq-options-container">
                                        <label className="input-label">
                                            Options {q.question_type === 'mcq_multi' ? '(Select multiple correct answers)' : '(Select one correct answer)'}:
                                        </label>
                                        <div className="options-grid">
                                            {q.options.map((opt, i) => (
                                                <div key={i} className="option-input-group">
                                                    <input
                                                        type={q.question_type === 'mcq_multi' ? "checkbox" : "radio"}
                                                        className={q.question_type === 'mcq_multi' ? "checkbox-custom" : "radio-custom"}
                                                        name={`correct-${qIndex}`}
                                                        checked={q.correct_answer.split(',').includes(opt) && opt !== ''}
                                                        onChange={() => handleToggleCorrect(qIndex, opt)}
                                                    />
                                                    <input
                                                        className="modern-input-sm"
                                                        placeholder={`Option ${i + 1}`}
                                                        value={opt}
                                                        onChange={e => handleOptionChange(qIndex, i, e.target.value)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-answer-container">
                                        <label className="input-label">Correct Answer Key:</label>
                                        <input
                                            className="modern-input"
                                            placeholder="Enter correct text (use '/' for multiple acceptable answers)"
                                            value={q.correct_answer}
                                            onChange={e => handleQuestionChange(qIndex, 'correct_answer', e.target.value)}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="sticky-form-actions">
                    <button onClick={addQuestion} className="btn-add-question">
                        + Add New Question
                    </button>
                    <button onClick={saveAll} className="btn-submit-save">
                        SAVE ALL QUESTIONS ✨
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminQuestions;